/**
 * Facebook Pixel conversion tracking helpers.
 * All functions are no-ops when the pixel script has not loaded.
 */

const fbq = (...args) => {
  if (typeof window.fbq === 'function') {
    window.fbq(...args);
  }
};

/** Fired when a new user successfully creates an account. */
export const trackCompleteRegistration = ({ method = 'email' } = {}) => {
  fbq('track', 'CompleteRegistration', { content_name: 'Sign Up', status: true, content_category: method });
};

/** Fired when an existing user successfully logs in. */
export const trackLead = ({ method = 'email' } = {}) => {
  fbq('track', 'Lead', { content_name: 'Login', content_category: method });
};

/** Fired when the user clicks Pay Now (checkout starts). */
export const trackInitiateCheckout = ({ plan, amount, currency = 'PHP' } = {}) => {
  fbq('track', 'InitiateCheckout', {
    content_name: plan,
    value: amount,
    currency,
    num_items: 1,
  });
};

/** Fired when a payment is confirmed/approved. */
export const trackPurchase = ({ plan, amount, currency = 'PHP', paymentId = '' } = {}) => {
  fbq('track', 'Purchase', {
    content_name: plan,
    value: amount,
    currency,
    content_ids: [paymentId],
    num_items: 1,
  });
};
